import { useState, useEffect } from 'react';
import { getAllNrtProducts, updateProductStock } from '../../../services/nrtService';
import { Row, Col, Form, Button, Alert, Accordion } from 'react-bootstrap';

const ProductStock = () => {
    const [products, setProducts] = useState([]);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getProducts = async () => {
            try {
                const result = await getAllNrtProducts();
                setProducts(result || []);
            } catch (error) {
                console.error("Error fetching NRT products:", error);
                setError("Failed to load products.");
            }
        };
        getProducts();
    }, []);

    const handleCheckboxChange = (productId) => {
        setProducts((prevProducts) =>
            prevProducts.map((product) =>
                product.id === productId
                    ? { ...product, isInStock: !product.isInStock }
                    : product
            )
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await updateProductStock(products);
            setMessage("Product stock updated successfully.");
            setError(null);
        } catch (error) {
            console.error("Error updating stock:", error);
            setError("Failed to update stock.");
            setMessage(null);
        }
    };
    return (
        <div className="component productStock">
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <Row>
                            <Col>
                                <h3>Product Stock</h3>
                            </Col>
                        </Row>
                    </Accordion.Header>
                    <Accordion.Body>
                        {message && <Alert variant="success">{message}</Alert>}
                        {error && <Alert variant="danger">{error}</Alert>}

                        <h5 className="mb-4">The form below shows the list of currently available NRT Products along with checkboxes showing the stock status of each item.<br />You can check/uncheck boxes and submit the form to update their stock status. This will affect the list of products available to coaches when ordering NRT for clients.</h5>

                        <Form onSubmit={handleSubmit}>
                            <div className="row">
                                {products.map((product) => (
                                    <div key={product.id} className="col-4">
                                        <Form.Group className="mb-3" controlId={`product-${product.id}`}>
                                            <Form.Check
                                                type="checkbox"
                                                label={product.name}
                                                checked={product.isInStock}
                                                onChange={() => handleCheckboxChange(product.id)}
                                            />
                                        </Form.Group>
                                    </div>
                                ))}
                            </div>
                            <Button type="submit" variant="primary">
                                Update Stock
                            </Button>
                        </Form>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
};

export default ProductStock;
